import cl from 'classnames'
import { Field as FormikField, Form, Formik } from 'formik'
import { Button, Field } from '@/ui'
import React, { memo, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import * as yup from 'yup'
import { string } from 'yup'
import { requirementLaborResourcesActions, requirementLaborResourcesThunks } from '@/entity/requirementLaborResources'

const FORM_NAME = {
	cropCode: 'cropCode',
	regId: 'regId',
	idRai: 'idRai',
	area: 'area',
}

const Validate = yup.object().shape({
	cropCode: string().required({ key: 'required' }).nullable(),
	regId: string().required({ key: 'required' }).nullable(),
	idRai: string().required({ key: 'required' }).nullable(),
	area: string().required({ key: 'required' }).nullable(),
})

export const CalcAgroForm = memo(({
																		handleSubmit,
																		initialState,
																		handleReset,
																		handleChange,
																		values,
																	}) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const ref = useRef(null)

	const { crop, cropDistricts } = useSelector((state) => ({
		crop: state.handbook.crop,
		cropDistricts: state.requirementLaborResources.cropDistricts,
	}))

	const handleChangeCulture = (value) => {
		let body = {
			data: value,
			onSuccess: (res) => {}
		}
		dispatch(requirementLaborResourcesThunks.getCropRegion(body))
	}

	const handleChangeRegion = (value) => {
		let body = {
			data: ref?.current?.values?.cropCode,
			params: {
				regionCode: value
			},
			onSuccess: (res) => {},
		}
		dispatch(requirementLaborResourcesThunks.getCropRai(body))
	}

	return (
		<Formik initialValues={initialState}
						onSubmit={handleSubmit} validationSchema={Validate} innerRef={ref}>
			{({ setValues }) => {
				return (
					<Form className={cl('flex', 'gap-3', 'align-items-start')}>
						<FormikField name={FORM_NAME.cropCode}>
							{({ field, meta: { touched, error } }) => (
								<Field
									{...field}
									fieldType={'select'}
									label={t('requirement_labor_resources.form.culture')}
									placeholder={t('requirement_labor_resources.form.choose_culture')}
									options={crop}
									value={values[FORM_NAME.cropCode]}
									error={touched && error}
									onChange={(value) => {
										field.onChange(value)
										handleChange({...values, [FORM_NAME.cropCode]: value, [FORM_NAME.regId]: null, [FORM_NAME.idRai]: null})
										setValues({...values, [FORM_NAME.cropCode]: value, [FORM_NAME.regId]: null, [FORM_NAME.idRai]: null})
										handleChangeCulture(value)
										dispatch(requirementLaborResourcesActions.getCalculatorActionReset('calcAgro'))
									}}
								/>
							)}
						</FormikField>

						<FormikField name={FORM_NAME.regId}>
							{({ field, meta: { touched, error } }) => (
								<Field
									{...field}
									fieldType={'select'}
									label={t('requirement_labor_resources.form.region')}
									placeholder={t('requirement_labor_resources.form.choose_region')}
									options={cropDistricts.region?.data || []}
									value={values[FORM_NAME.regId]}
									error={touched && error}
									onChange={(value) => {
										field.onChange(value)
										handleChange({...values, [FORM_NAME.regId]: value, [FORM_NAME.idRai]: null})
										setValues({...values, [FORM_NAME.regId]: value, [FORM_NAME.idRai]: null})
										handleChangeRegion(value)
										dispatch(requirementLaborResourcesActions.getCalculatorActionReset('calcAgro'))
									}}
								/>
							)}
						</FormikField>

						<FormikField name={FORM_NAME.idRai}>
							{({ field, meta: { touched, error } }) => (
								<Field
									{...field}
									fieldType={'select'}
									label={t('requirement_labor_resources.form.district')}
									placeholder={t('requirement_labor_resources.form.choose_district')}
									options={cropDistricts.rai?.data || []}
									value={values[FORM_NAME.idRai]}
									error={touched && error}
									onChange={(value) => {
										field.onChange(value)
										handleChange({...values, [FORM_NAME.idRai]: value})
										setValues({...values, [FORM_NAME.idRai]: value})
									}}
								/>
							)}
						</FormikField>

						<FormikField name={FORM_NAME.area}>
							{({ field, meta: { touched, error } }) => (
								<Field
									{...field}
									fieldType={'input'}
									type="number"
									min={0}
									hideNumberArrows
									label={t('requirement_labor_resources.form.square_crops')}
									placeholder={t('requirement_labor_resources.form.square')}
									value={values[FORM_NAME.area]}
									error={touched && error}
									onChange={(value) => {
										field.onChange(value)
										handleChange({...values, [FORM_NAME.area]: value})
										setValues({...values, [FORM_NAME.area]: value})
									}}
								/>
							)}
						</FormikField>

						<div className={cl('flex', 'align-items-end')} style={{height: 70}}>
								<div className={cl('flex', 'gap-3', 'align-items-center')}>
									<Button type="submit">
										{t('requirement_labor_resources.calculate')}
									</Button>

									<Button type="bare" onClick={() => {
										handleReset()
										setValues(initialState)
										dispatch(requirementLaborResourcesActions.getCropRaiActionDone([]))
										dispatch(requirementLaborResourcesActions.getCropRegionActionDone([]))
									}}>
										{t('reset_all')}
									</Button>
								</div>
						</div>
					</Form>
				)
			}}
		</Formik>
	)
})